<template>
  <div class="bg-dark-create" :class="[showmodal ? 'open' : '']"></div>
  <div class="form-create-module editquestion" :class="[showmodal ? 'open' : '']">
    <div class="modal editquestion" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Editar questão</h5>
          </div>
          <div class="modal-body">
            <section class="section link-list primary">
              <div class="link-list-content">
                <div class="content-link create-course">
                  <div class="link" @click="changeView(0)">
                    <a class="link-content" :class="[viewtab ? 'active' : '']">
                      Questão
                    </a>
                  </div>
                  <div class="link" @click="changeView(1)">
                    <a class="link-content" :class="[!viewtab ? 'active' : '']">
                      Alternativas
                    </a>
                  </div>
                </div>
              </div>
            </section>

            <div class="form-group" v-show="viewtab">
              <QuillEditor
               theme="snow" 
               toolbar="essential"
              v-model:content="titleQuestion" contentType="html" />
            </div>

            <div class="form-group" v-show="!viewtab">
               <div class="question" v-for="answer, index in content" :key="index">
                <div class="input_awmser">
                  <input type="radio" name="correct" v-model="correctOption" :value="index+1" :checked="answer.correct == 1">
                  <label>{{titleOption[index]}}</label>
                </div>
                <div class="text_awmser">
                  <QuillEditor
                  @input="updateContent(i, $event.srcElement.innerHTML)"
                  theme="snow"
                  toolbar="essential"
                  v-model:content="answer.description"
                  contentType="html"
                />
                </div>
            </div> 
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" @click="closetab()" class="btn btn-secondary" data-bs-dismiss="modal">
              Cancelar
            </button>
            <button type="button" @click="saveModule()" class="btn btn-primary">
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '@/utils/answer'
import { QuillEditor } from '@vueup/vue-quill';
import { mapState } from 'vuex'; 
export default {
  data() {
    return {
      showmodal: '',
      nameModule: '',
      demo: '',
      content: [],
      viewtab: true,
      titleQuestion: null,
      correctOption: null,
      titleOption: ['A', 'B', 'C', 'D', 'E'],
      numberAnswer: 0,
    }
  },
  props: {
    show: Boolean,
    id: Number,
    title: String,
    idQuiz: Number
  },
  computed:{
    ...mapState(['token'])
  },
  methods: {
    getCorrectIndex() {
      for (let i = 0; i < this.content.length; i++) {
        if (this.content[i].correct === 1) {
          this.correctOption = i;
        }
      }
    },
    closetab() {
      this.showmodal = false;
      this.$emit('open-tab', this.showmodal)
    },
    opentab() {
      this.show = true,
        this.$emit('open-tab', this.showmodal)
    },
    saveModule() {
      this.editQuestion();
      this.showmodal = false;
      this.$emit('open-tab', this.showmodal)
    },
    criarObjetoDeRespostas(arrayDeRespostas) {
        return arrayDeRespostas.map((resposta, index) => ({
        id: resposta.id,
        order: index,
        correct: this.correctOption === index ? this.content[index].id : '',
        description: resposta.description
    }));
    },
    async editQuestion(){
      const obj = {
          "question": {
            "description": this.titleQuestion,
            "status": 1,
            "order": 1,
            "quiz": {
                "id": this.idQuiz
            }
          },
          "answers": this.criarObjetoDeRespostas(this.content)
        }
        console.debug(obj);
      try {
        const response = await api.editQuestionAnswer(this.id, obj ,this.token)
        console.debug(response)
      } catch (error) {
        console.error('Erro ao atualizar', error)
      }
    },
    async getDataAnswer(){
      try {
        const response = await api.getAnswerByQuestion(this.id, this.token)
        console.debug('question', response.content)
        this.content =  response.content;
        this.numberAnswer =  response.content.length;
        this.getCorrectIndex();
      } catch (error) {
        console.error('Erro ao carregar as respostas', error)
      }
    },
    changeView(id) {
      if (id == 0) {
        this.viewtab = true;
      } else {
        this.viewtab = false;
      }
    },
    updateContent(index, event) {
      this.content[index] = event
    }
  },
  watch: {
    show(novoValor) {
      this.showmodal = this.show;
      this.getDataAnswer();
      this.titleQuestion = this.title;
    },
  }
};
</script>
<style scoped>
@import "./tabs.css";
.form-create-module.editquestion {
  z-index: 9999!important;
}
.input_awmser {
  width: 10%;
  vertical-align: middle;
}

.question {
  display: flex;
  padding: 10px;
}

.text_awmser {
  width: 95%;
}

.question .ql-editor {
  min-height: 85px !important;
}

.input_awmser label {
  padding-left: 10px;
}
.form-create-module.editquestion {
  z-index: 9999!important;
}
.form-create-module.editquestion.open .modal-body {
    margin: 0;
    padding: 0;
}
.dashboard.dark .form-group {
margin: 0px !important;
padding: 7px;
border: 1px solid #a4a4a4;
margin-top: 0px !important;
}
.dashboard.dark .input_awmser label {
color: white;
}
.modal-body {
margin: 8px;
}
.form-create-module.question-quiz .form-group {
  margin: 0 !important;
  padding: 5px 5px;
}
</style>
